import React from 'react';
import { Typography, type TypographyProps } from '@mui/material';

interface TextComponentProps extends TypographyProps {
  children: React.ReactNode;
}

export const TextComponent = ({ children, ...rest }: TextComponentProps) => (
  <Typography variant="subtitle2" fontWeight={600} {...rest}>
    {children}
  </Typography>
);
